import { render, staticRenderFns } from "./DownloadIfram.vue?vue&type=template&id=b142ca28&scoped=true&"
import script from "./DownloadIfram.vue?vue&type=script&lang=js&"
export * from "./DownloadIfram.vue?vue&type=script&lang=js&"
import style0 from "./DownloadIfram.vue?vue&type=style&index=0&id=b142ca28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b142ca28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b142ca28')) {
      api.createRecord('b142ca28', component.options)
    } else {
      api.reload('b142ca28', component.options)
    }
    module.hot.accept("./DownloadIfram.vue?vue&type=template&id=b142ca28&scoped=true&", function () {
      api.rerender('b142ca28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MessageAgentSub/DownloadIfram.vue"
export default component.exports